import React from "react";
import { MARQUEE_ITEMS } from "../mock";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative bg-[#1b5e3a] text-[#f4ecd8] py-5 overflow-hidden border-y border-[#c4a257]/30">
      <div className="flex whitespace-nowrap animate-marquee gap-14">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-14 flex-shrink-0">
            <span className="font-serif text-lg md:text-xl tracking-wide">{it}</span>
            <span className="text-[#c4a257] text-2xl">·</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
